import React, { useState } from "react";
import LeaveSidePanel from "./LeaveSidePanel"; // NEW

const LeaveManagementList = ({ loading, leavemanagements, role, onRefresh }) => {
  const [selectedLeave, setSelectedLeave] = useState(null);

  const openPanel = (leave) => setSelectedLeave(leave);
  const closePanel = () => setSelectedLeave(null);

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow-sm border-0">
          <div className="card-header bg-white border-0">
            <h5 className="fw-bold mb-0">Employee Leave Details</h5>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-light">
                  <tr className="text-secondary small text-uppercase">
                    <th>Emp ID</th>
                    <th>Name</th>
                    <th>Dept</th>
                    <th>Leave Type</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center py-4 text-muted">
                        Loading...
                      </td>
                    </tr>
                  ) : (
                    leavemanagements.map((l) => (
                      <tr
                        key={l.id}
                        style={{ cursor: "pointer" }}
                        onClick={() => openPanel(l)}
                      >
                        <td>{l.employee.employee_code}</td>
                        <td>
                          {l.employee.first_name} {l.employee.last_name}
                        </td>
                        <td>{l.employee.department}</td>
                        <td>{l.type.short_name}</td>
                        <td>{l.from_date}</td>
                        <td>{l.to_date}</td>
                        <td>
                          <span className={`badge bg-warning text-dark`}>
                            {l.status}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* SIDEBAR COMPONENT */}
      {selectedLeave && (
        <LeaveSidePanel
          leave={selectedLeave}
          role={role}
          onClose={closePanel}
          onRefresh={onRefresh}
        />
      )}
    </>
  );
};

export default LeaveManagementList;
